<template>
	<section>

		<main class="container">
			<div class="row">
				<div class="col text-center">

					<h2 v-if="freeRoomsForBooking > 0" class="my-8 py-8 col-md-12">{{ $t('checkin.roomCategory.title') }}</h2>
					<span v-else></span>
					<form class="needs-validation" novalidate>
						<div class="row mb-12" v-if="freeRoomsForBooking > 0">
							<!-- Zimmer Infos -->
							<div class="col-5 card-col" v-for="roomCategory in allRoomCategories">
								<div class="card card-style" :class="[selectedClass, {'booked-out':!roomCategoryHasVacancies(roomCategory)}]">

									<div class="card-img-top" @click.prevent="roomSelect(roomCategory)">
										<SlideShow :images="getImages(roomCategory)"></SlideShow>
									</div>

									<div class="card-body">
										<a class="room-select" @click.prevent="roomSelect(roomCategory)"></a>
										<h2 class="card-title">{{ $t( roomCategory.roomTitle ) }}</h2>
										<template v-if="roomCategoryHasVacancies(roomCategory)">
											<p>
												{{ $t( roomCategory.description ) }}
											</p>
											<p class="additional-description" v-if="roomCategory.addDescription" v-html="$t( roomCategory.addDescription )"></p>
											<p class="price">Preis / Nacht {{ roomCategory.price }} &euro;</p>
											<a class="info" data-toggle="modal" :data-target="getRoomCategoryId(roomCategory,1)">i</a>
										</template>
										<template v-else>
											<p>{{ $t( 'checkin.roomCategory.full' ) }}</p>
										</template>
									</div>
								</div>
							</div>
							<!-- /Zimmer Infos -->
						</div>
						<div v-else class="row mb-12 mt-12 py-12">
							<div class="col text-center">
								<img src="/assets/images/hellers24.svg" class="logo mb-20"/>
								<h2 class="col-md-12">{{ $t( 'checkin.roomCategory.allRoomsFullHeader' ) }}</h2>
								<p v-html="$t( 'checkin.roomCategory.allRoomsFull' )"></p>
							</div>
						</div>

						<div class="row pt-3">
							<div class="col-md-3 text-left">
								<a @click.prevent="lastStep" class="btn btn-secondary btn-prev">{{ $t('checkin.cancel') }}</a>
							</div>
							<div class="col-md-6 pt-3 dots">
								<p><span class="dot active"></span> <span class="dot"></span> <span class="dot"></span></p>
							</div>

							<div class="col-md-3 text-right" v-if="false">
								<button @click.prevent="nextStep" class="btn btn-primary btn-next" type="submit">{{ $t('checkin.next') }}</button>
							</div>
						</div>
					</form>
				</div>
			</div>

			<div v-for="roomCategory in allRoomCategories" class="modal fade" :id="getRoomCategoryId(roomCategory,0)" tabindex="-1" role="dialog" aria-hidden="true">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">{{ $t( roomCategory.roomTitle ) }}</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<span v-html="$t( roomCategory.roomInfo )"></span>
						</div>
					</div>
				</div>
			</div>

		</main>
	</section>
</template>

<script>

		import axios from 'axios'
		import { mapState } from 'vuex';
		import Flickity from 'vue-flickity';
		import SlideShow from './SlideShow.vue'

		export default {
			props: [],
			data: function () {
				return {
					allRoomCategories: null,
					selectedRoomCategory: null,
					showError: false,
					selectedClass: null,
					selected2Class: null,
					freeRoomsForBooking: null,
					freeRoomsForBookingByCategory: {}
				}
			},
			computed: {
				...mapState('settings', ['config']),
				bookingRoomCategoryCodes() {
					return this.config.bookingRoomCategoryCodes;
				}
			},

			created: function() {
				this.$parent.guest = {};
				this.getRoomCategoriesFromArray();
				this.getFreeRoomsForBooking();
			},

			methods: {
				lastStep() {
					this.$parent.direction = false;
					this.$parent.guest = {};
					this.$parent.component = 'CheckinStart';
				},
				nextStep() {
					this.$parent.direction = true;
					let self = this;
					this.$parent.component = 'CheckinCreditCard'
				},

				/**
				 * Return list of images to show on tile for room category.
				 * Images are defined in common/config.js
				 *
				 * @return Array
				 */
				getImages(roomCategory) {
					var images = [];
					this.config.bookingRoomCategoryCodes.forEach((item) => {
						if (roomCategory.code == item.code) {
							images = item.images;
						}
					});
					return images;
				},

				/**
				 * Return true, if there are rooms available for give categoryCode (i.e. 'TER1').
				 *
				 * @return Boolean
				 */
				roomCategoryHasVacancies(roomCategory) {					
					var configurationForRoomCategory = this.getRoomConfigurationForCategory(roomCategory);
					var code = configurationForRoomCategory.overrideCode;

					if (!this.freeRoomsForBookingByCategory) return false;
					if (!this.freeRoomsForBookingByCategory[code]) return false;
					return true;
				},

				/*
				 * The checking for a certain category can be overriden with the property `overrideCode`
				 * in the config.js.
				 * 
				 * @return Array
				 */
				getRoomConfigurationForCategory( roomCategory ) {
					var roomCategoryCode = roomCategory.code;

					// Check, if category is overriden: Even if it would actually be a TER2, only TER1 are booked in the process
					var configurationForRoomCategory = {};
					this.config.bookingRoomCategoryCodes.forEach((item) => {
						if (item.code == roomCategoryCode || item.overrideCode == roomCategoryCode) {
							configurationForRoomCategory = item;
						}
					});
					return configurationForRoomCategory;
				},

				getRoomCategoriesFromArray() {
					let tmpArRoomCategories = {};
					let formData = new FormData();
					formData.append('bookingRooms', JSON.stringify(this.bookingRoomCategoryCodes));

					axios({
						method: 'post',
						url: this.config.apiUrl + 'getBookingRoomCategories',
						withCredentials: true,
						data: formData
					}).then(response => (this.allRoomCategories = response.data))
					return this.allRoomCategories;
				},

				/**
				 * Get list of free rooms (total number and by category) from backend.
				 *
				 * @return Promise
				 */
				getFreeRoomsForBooking() {
					console.log(this.config.apiUrl + 'getFreeRoomsByCategoryForBooking')
					axios({
						method: 'post',
						url: this.config.apiUrl + 'getFreeRoomsByCategoryForBooking',
						withCredentials: true,
					}).then(response => {
						this.freeRoomsForBooking = response.data.returnValue.total;
						this.freeRoomsForBookingByCategory = response.data.returnValue;
						console.log(response)
					})
				},

				/**
				 * User selected a room category by clicking on tile.
				 *
				 */
				roomSelect(roomCat) {
					var configurationForRoomCategory = this.getRoomConfigurationForCategory(roomCat);
					console.log('selected room cat:', roomCat);
					console.log('selected room cat config:', configurationForRoomCategory);
					this.$parent.guest.roomCategory = Object.assign({}, roomCat);
					this.$parent.guest.roomCategoryConfig = Object.assign({}, configurationForRoomCategory);
					this.nextStep();
				},

				getRoomCategoryId(roomCat,prefix) {
					var returnString =  'cat-' + roomCat.objId;
					if(prefix == 1) {
						returnString =  '#' + returnString;
					}
					return returnString;
				},

				/** Keyboard Events **/
				accept(text) {
					this.$parent.accept(text);
				},
				show(e) {
					this.$parent.show(e);
				},

				hide() {
					this.$parent.hide();
				},

				next() {
					this.$parent.next();
				}


			},
			components: {
				SlideShow
			}
		}
</script>

<style scoped lang="scss">
	.card-col:first-child {
		margin-left: 8.333333%;
	}
	.booked-out {
		pointer-events: none;
		user-select: none;
	}
	.card {
		cursor: pointer;
		height: 100%;
		line-height: 1.3;
		border-radius: 0;
		border: 0;
		-webkit-box-shadow: 0 5px 10px rgba(0,0,0,.25);
		box-shadow: 0 5px 10px rgba(0,0,0,.25);

		h2 {
			font-size: 1.75rem;
			font-weight: bold;
			background-image: linear-gradient(90deg,#b78417,#ead66a,#b78417);
		}

		p {
			font-size: 1.25rem;
			color: #000;
			&.additional-description {
				margin-bottom: 3rem;
			}
		}
		.card-body {
			position: relative;
		}
		.room-select {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
		}
		.price {
			position: absolute;
			bottom: 1.25rem;
			margin-bottom: 0;
			left: 0;
			right: 0;
			font-weight: bold;
		}

		.info {
			position: absolute;
			z-index: 100;
			right: 1rem;
			bottom: 1rem;
			background-image: linear-gradient(135deg,#989fa4,#c8d3d9,#989fa4);
			width: 2.5rem;
			height: 2.5rem;
			color: #000;
			font-weight: bold;
			border-radius: 100%;
			padding-top: .5rem;
			font-size: 1.25rem;
			&:hover,
			&:focus,
			&:active {
				color: #000;
			}
		}
	}
	.modal-content {
		border: 0;
		border-radius: 0;
		-webkit-box-shadow: 0 5px 10px rgba(0,0,0,.25);
		box-shadow: 0 5px 10px rgba(0,0,0,.25);
		.modal-header {
			h5 {
				font-size: 1.75rem;
				font-weight: bold;
				text-transform: uppercase;
				background-image: linear-gradient(90deg,#b78417,#ead66a,#b78417);
				margin-left: 0;
			}
			.close {
				padding: 1rem 1rem .6rem;
				span {
					font-size: 3rem;
				}
			}
		}
		.modal-body {
			color: #000;
			font-size: 1.25rem !important;
		}
	}
</style>

<style lang="scss">
.modal-body p {
	font-size: 1.25rem !important;
}
.modal-backdrop {
	z-index: -1 !important;
}
</style>
